




















































import CollapsiblePanel from "../../core/UI/CollapsiblePanel.vue";
import { Contact } from "../../models/Contact";
import FactureFournisseurModal from "../../document/FactureFournisseurModal.vue";

export default {
    name: "ContactFacturesList",
    components: {
        FactureFournisseurModal,
        CollapsiblePanel,
    },
    props: {
        contact: Contact,
    },
    data() {
        return {
            factureFournisseurModal: {
                factureFournisseurId: null,
            },
        };
    },
    methods: {
        editFacture(facture) {
            this.factureFournisseurModal.factureFournisseurId = facture.id;
        },
        onFactureFournisseurModalClose() {
            this.factureFournisseurModal.factureFournisseurId = null;
        },
    },
};
